const getAlerts = state => {
    return state.alerts;
};

export default {
    getAlerts,
};
